import api from '@seller-hermes/utils/api';
import type {
  PortalMeResponse,
  PortalProfile,
  PortalSellerGroupContext,
} from './portal.types';

const PORTAL_PROFILES: PortalProfile[] = ['LOG', 'GO', 'PAY'];

const isPortalProfile = (value?: string | null): value is PortalProfile =>
  Boolean(value && PORTAL_PROFILES.includes(value as PortalProfile));

const normalizePortalMe = (portalMe: PortalMeResponse): PortalMeResponse => ({
  ...portalMe,
  seller_groups: withUnavailableProductPlaceholders(
    portalMe.seller_groups
      .filter((context) => isPortalProfile(context.profile))
      .map((context) => ({
        ...context,
        status: context.status || 'available',
        is_default:
          context.is_default ||
          portalMe.default_seller_group?.id === context.id,
      })),
  ),
});

const withUnavailableProductPlaceholders = (
  contexts: PortalSellerGroupContext[],
): PortalSellerGroupContext[] => {
  const profiles = new Set(contexts.map((context) => context.profile));
  const placeholders: PortalSellerGroupContext[] = [];

  if (!profiles.has('LOG')) {
    placeholders.push({
      id: 'unavailable-log',
      name: 'Ative o Abbiamo LOG',
      description:
        'Cotacao de frete, gestao de pedidos e integracao com transportadoras.',
      profile: 'LOG',
      is_homologation: false,
      status: 'unavailable',
      status_label: 'Produto ainda nao disponivel',
      metric_label: 'Para contas habilitadas',
    });
  }

  if (!profiles.has('GO')) {
    placeholders.push({
      id: 'unavailable-go',
      name: 'Ative o Abbiamo GO',
      description:
        'Rotas, motoristas e execucao de entregas com frota propria.',
      profile: 'GO',
      is_homologation: false,
      status: 'unavailable',
      status_label: 'Produto ainda nao disponivel',
      metric_label: 'Para contas habilitadas',
    });
  }

  return [...contexts, ...placeholders];
};

export class PortalService {
  static async getMe() {
    const res = await api.get<PortalMeResponse>('/portal/me');
    return normalizePortalMe(res.data);
  }
}
